import { Component, Input, OnInit } from '@angular/core';
import ISI from '../../data/isi.json';
import { GoogleService, ModalService } from 'src/app/services';
import modalData from '../../data/modals.json';
import { Modal } from 'src/app/models';

@Component({
    selector: 'app-medicine',
    templateUrl: './medicine.component.html',
    styleUrls: ['./medicine.component.scss']
})
export class MedicineComponent implements OnInit {
    @Input() data: any;

    public isiData: any = undefined;
    public isiOpen: boolean = false;
    public hideClose: boolean = false;

    constructor(
        private modalSvc: ModalService,
        private googleSvc: GoogleService
    ) { }

    ngOnInit(): void {
        this.isiData = ISI.find(el => el.id === this.data.isi);

        if (this.data.isi_expanded) {
            this.isiOpen = true;
            this.hideClose = true;
        } else {
            this.isiOpen = false;
        }
    }

    public contentLinkAction(link: any) {
        if (link.modal) {
            this.modalSvc.setActiveModalById(link.modal, link);

            if (!link.external) {
                const modal: Modal = modalData.find(el => el.id === link.modal);
                this.googleSvc.sendGAEventById(10, { category: modal.title, label: modal.pdf });
            }
        }

        this.data.isi_expanded = false;
    }

    public openIsi(): void {
        this.isiOpen = true;
        this.googleSvc.sendGAEventById(7, { category: this.data.medicine, label: 'open' });
    }

    public closeIsi(): void {
        this.googleSvc.sendGAEventById(7, { category: this.data.medicine, label: 'close' });
        setTimeout(() => { this.isiOpen = false; }, 10);
    }
}
